import React from "react";
import { Link } from "react-router-dom";
import { companyConfig } from "../config/company";
import "./Footer.css";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-links">
          <Link to="/impressum" className="footer-link">
            Impressum
          </Link>
          <Link to="/kontakt" className="footer-link">
            Kontakt
          </Link>
          <Link to="/datenschutz" className="footer-link">
            Datenschutz
          </Link>
        </div>
        <div className="footer-copyright">
          <p>
            © {currentYear} {companyConfig.name}
          </p>
          <p>Made with ❤️ in {companyConfig.location.city}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
